import { Stack, chipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "SocialOffersDetailsInfoStack";
export const classes = {
  root: `${PREFIX}-root`,
  section: `${PREFIX}-section`,
  title: `${PREFIX}-title`,
  content: `${PREFIX}-content`,
  description: `${PREFIX}-description`,
};

export const SocialOffersDetailsInfoStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: "flex",
    flexDirection: "column",
    flex: "0 0 355px",
    height: "100%",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    alignItems: "center",
    justifyContent: "start",
    minWidth: 0,
    maxWidth: "355px",
    minHeight: 0,
    overflow: "hidden",
    [theme.breakpoints.down("tablet")]: {
      flex: "0 1 auto",
      maxWidth: "100%",
      height: "auto",
    },
  },
  [`& .${classes.section}`]: {
    width: "100%",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    minWidth: 0,
    overflow: "hidden",
    "& *": {
      minWidth: 0,
    },
  },
  [`& .${classes.title}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "top",
    gap: theme.spacing(1),
  },
  [`& .${classes.content}`]: {
    flex: "0 1 auto",
    overflow: "auto",
    width: "100%",
    gap: theme.spacing(2),
    minHeight: 0,
  },
  [`& .${classes.description}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    gap: theme.spacing(1),
    flex: "1 1 auto",
    minHeight: 200,
    overflow: "auto",
  },
}));

const INFO_CARD_PREFIX = "InfoCard";

export const infoCardClasses = {
  root: `${INFO_CARD_PREFIX}-root`,
};

export const InfoCard = styled(Stack)(({ theme }) => ({
  [`&.${infoCardClasses.root}`]: {
    backgroundColor: theme.palette.surface.main,
    borderRadius: 4,
    padding: theme.spacing(2),
    gap: theme.spacing(1),
    minWidth: 0,
    overflow: "hidden",
    "& *": {
      minWidth: 0,
    },
    [`& .${chipClasses.root}`]: {
      alignSelf: "start",
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      [`& .${chipClasses.label}:first-letter`]: {
        textTransform: "uppercase",
      },
    },
  },
}));
